/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FaTicketAlt } from "react-icons/fa";
import ReactTable from "react-table";
import ResponsiveDataComponent from "../common/ResponsiveDataComponent";
import { formatDuration } from "../../helpers";

import {
  SUPPORT_TICKET_COLUMNS,
  SUPPORT_TICKET_COLUMNS_MOBILE
} from "./columns";

import HeaderWrapper from "../common/HeaderWrapper";
import Badge from "../common/Badge";

import SupportTicketService from "../../services/supportTicketService";

const useFetch = (range, userId, departmentId) => {
  const [aggregateTickets, setAggregateTickets] = useState([]);
  const [dashboardTickets, setDashboardTickets] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const query = {
        startDate: range.start,
        endDate: range.end,
        assigned_to: userId
      };

      const aggregateResult =
        await SupportTicketService.aggregateByStatus(query);
      setAggregateTickets(aggregateResult);

      const ticketResult =
        await SupportTicketService.getDashboardTickets(query);
      setDashboardTickets(ticketResult);
    };
    fetchData();
  }, [departmentId, range.end, range.start, userId]);
  return { aggregateTickets, dashboardTickets };
};

const DashboardTickets = ({
  auth,
  history,
  userId,
  departmentId,
  user,
  range,
  isMobile,
  dragState
}) => {
  const { aggregateTickets, dashboardTickets } = useFetch(
    range,
    userId,
    departmentId
  );

  const handleStatusClick = (ticket) => () => {
    if (!dragState.dragInProcess && dragState.dragOver) {
      const newFilters = {
        multi_assigned_to:
          user && user.value ? [{ label: user.label, value: user.value }] : [],
        request_status: [{ label: ticket.request_status, value: ticket.id }]
      };
      localStorage.setItem("ticket-filters", JSON.stringify(newFilters));

      history.push("/app/support-tickets");
    }
  };

  const getLabel = () => {
    if (user) {
      if (user.label === auth.user.full_name) {
        return "My Tickets";
      }

      return `${user.label}'s Tickets`;
    }
    return "All Tickets";
  };

  const props = {
    getTdProps: (state, rowInfo, column) => {
      if (!dragState.dragInProcess && dragState.dragOver && !column.expander) {
        return {
          onClick: () => {
            if (
              column.id !== "request_priority" &&
              column.id !== "request_nature_details" &&
              rowInfo?.original?._id
            ) {
              history.push(`/app/support-tickets/${rowInfo.original._id}`);
            }
          }
        };
      }
      return {};
    }
  };

  return (
    <React.Fragment>
      <HeaderWrapper
        breadcrumbs={[{ label: getLabel() }]}
        icon={
          <Badge className="round">
            {
              dashboardTickets.filter(
                (tick) =>
                  tick.request_status.label === "In Process" ||
                  tick.request_status.label === "Resolved"
              ).length
            }
          </Badge>
        }
      />
      <div className="dashboard-ticket-row">
        <div className="content-wrapper">
          <div className="dashboard-call-status-row tickets-row">
            {aggregateTickets.map((ticket, id) => (
              <div
                key={id}
                className="ticket-status-container"
                role="presentation"
                onKeyDown={() => {}}
                onClick={handleStatusClick(ticket)}
              >
                <div className="text">
                  <h1 className="title">{ticket.total}</h1>
                  <h2 className="subtitle">{ticket.request_status}</h2>
                </div>
                <div className="icon">
                  <FaTicketAlt color={ticket.color} size={220} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="content-wrapper">
          <ReactTable
            {...props}
            data={dashboardTickets.filter(
              (tick) =>
                tick.request_status.label === "In Process" ||
                tick.request_status.label === "Resolved"
            )}
            columns={
              isMobile ? SUPPORT_TICKET_COLUMNS_MOBILE : SUPPORT_TICKET_COLUMNS
            }
            defaultPageSize={4}
            className="-highlight tickets"
            showPageSizeOptions={false}
            defaultSorted={[
              { id: "request_status", desc: false },
              { id: "age", desc: true }
            ]}
            manual
            SubComponent={
              isMobile
                ? ({ original }) => (
                    <ResponsiveDataComponent
                      data={[
                        {
                          key: "Status",
                          label: original.request_status.label
                        },
                        {
                          key: "Customer",
                          label: original.requestor_company_name
                        },
                        {
                          key: "Age",
                          label: formatDuration(original.age, [
                            "day",
                            "hour",
                            "minute"
                          ])
                        }
                      ]}
                    />
                  )
                : false
            }
          />
        </div>
      </div>
      {/* <pre>
        <code>{JSON.stringify(dashboardTickets, null, 2)}</code>
      </pre> */}
    </React.Fragment>
  );
};

DashboardTickets.propTypes = {
  auth: PropTypes.object,
  history: PropTypes.object,
  range: PropTypes.object,
  userId: PropTypes.string,
  departmentId: PropTypes.string,
  user: PropTypes.object,
  isMobile: PropTypes.bool,
  dragState: PropTypes.object
};

DashboardTickets.defaultProps = {
  dragState: {}
};

export default DashboardTickets;
